.qpsPushProgressOverlay {
  margin: 0 24px;
  position: fixed;
  bottom: 0;
  right: 0;
  transition: transform 0.2s ease-in-out, opacity 0.2s ease-in-out;

  &.drawerIsOpen {
    opacity: 0;
  }
}
